/**
 * ActionCable Consumer Configuration
 *
 * Creates a WebSocket consumer for real-time communication with the Rails backend.
 * Used for receiving live updates about file processing status and other real-time events.
 *
 * Configuration:
 * - Development: ws://localhost:3000/cable
 * - Production: Configured via REACT_APP_WEBSOCKET_URL or REACT_APP_WS_URL environment variable
 */

import { createConsumer } from '@rails/actioncable';

// Determine WebSocket URL with consistent logic across the app
const getWebSocketUrl = () => {
  let wsUrl;

  // Priority 1: REACT_APP_WEBSOCKET_URL (used by most services)
  if (process.env.REACT_APP_WEBSOCKET_URL) {
    wsUrl = process.env.REACT_APP_WEBSOCKET_URL;
  }
  // Priority 2: REACT_APP_WS_URL (legacy)
  else if (process.env.REACT_APP_WS_URL) {
    wsUrl = process.env.REACT_APP_WS_URL;
  }
  // Priority 3: Derive from REACT_APP_PRODUCTION_URL
  else if (process.env.REACT_APP_PRODUCTION_URL) {
    const apiUrl = process.env.REACT_APP_PRODUCTION_URL.replace(/\/$/, '');
    wsUrl = apiUrl.replace(/^https?/, 'wss');
    if (!wsUrl.endsWith('/cable')) {
      wsUrl = wsUrl.endsWith('/') ? `${wsUrl}cable` : `${wsUrl}/cable`;
    }
  }
  // Default: localhost for development
  else {
    wsUrl = 'ws://localhost:3000/cable';
  }

  // CRITICAL: Ensure wss:// for HTTPS pages to avoid Mixed Content errors
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && wsUrl.startsWith('ws://')) {
    console.warn('[ActionCable] Converting ws:// to wss:// for HTTPS page');
    wsUrl = wsUrl.replace(/^ws:/, 'wss:');
  }

  return wsUrl;
};

const wsUrl = getWebSocketUrl();
console.log('[ActionCable] Connecting to:', wsUrl);

// Create and export the ActionCable consumer instance
const consumer = createConsumer(wsUrl);

// Debug: Log consumer state
console.log('[ActionCable] Consumer created:', {
  url: wsUrl,
  consumer: consumer,
  subscriptions: consumer?.subscriptions
});

export default consumer;
